import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-approval-info',
  templateUrl: './approval-info.component.html',
  styleUrls: ['./approval-info.component.scss']
})
export class ApprovalInfoComponent implements OnInit {
  showModal = false;
  _tableData: any[] = [];

  @Input()
  set tableData(v) {
    this._tableData = v;
  }

  get tableData() {
    return this._tableData;
  }

  @Input()
  set modalVisible(v) {
    this.showModal = v;
  }

  get modalVisible() {
    return this.showModal;
  }

  @Output() modalState = new EventEmitter();

  constructor() {
  }

  ngOnInit(): void {
  }

  handleCloseModal() {
    this.modalState.emit(false);
  }
}
